module.exports = __webpack_public_path__ + "src/assets/img/pic (6).0e2d2f58.jpg";